<template>
  <div id="reportPage">
    <main>
      <article>
        <div class="title-wrapper mb-4">
          <h2 class="login-title">CROSS SALES CONFIGURATOR</h2>
          <UserMenu :roles="roles" :user-name="userName" />
        </div>
        <div class="action-bar mb-4">
          <button class="btn btn-primary" @click="openCreateModal">
            + Create
          </button>
        </div>
        <div v-if="showCreateModal" class="modal-overlay">
          <div class="modal-content" @click.stop>
            <h2 class="modal-title">Create limit</h2>

            <form @submit.prevent="createQuota" class="modal-form">
              <div class="conditional-text">
                <span>For cluster </span>
                  <Multiselect
                    v-model="creatingRow.cluster"
                    :options="clusterOptions"
                    label="name"
                    track-by="name"
                    placeholder="Select cluster"
                    @input="onCreateClusterChange"
                    :allow-empty="true"
                    class="multiselect-sm"
                  />

                  <span> and campaign </span>
                  <Multiselect
                    v-model="creatingRow.campaign"
                    :options="creatingRow.filteredCampaigns"
                    label="campaign_name"
                    placeholder="Select campaign"
                    :allow-empty="true"
                    class="multiselect-sm"
                  />

                <span>if current insurance carrier is</span>
                <Multiselect
                  v-model="creatingRow.insurance_company"
                  :options="insuranceOptions"
                  label="name"
                  track-by="id"
                  placeholder="Select insurance"
                  :allow-empty="true"
                  class="multiselect-sm"
                  :searchable="true" 
                  :append-to-body="false"
                />
                <span> and state is </span>
                <Multiselect
                  v-model="creatingRow.states"
                  :options="stateOptions"
                  label="name"
                  track-by="name"
                  placeholder="Select state"
                  mode="tags"
                  :allow-empty="true"
                  class="multiselect-sm"
                  :searchable="true"
                  :multiple="true"
                  :close-on-select="false"
                />
                <span> then transfer to </span>
                <input
                  v-model="creatingRow.phone_number"
                  placeholder="Phone"
                  required
                  class="small-field phone-field"
                />
                <span> with publisher key </span>
                <input
                  v-model="creatingRow.publisher_key"
                  placeholder="publisher key"
                  required
                  class="small-field"
                />
                
                <span> and daily limit </span>
                <input
                  type="number"
                  v-model="creatingRow.calls_limit"
                  placeholder="Quota"
                  required
                  class="small-field"
                />
              </div>

              <div class="modal-actions mt-3">
                <button type="button" class="btn btn-secondary" @click="closeCreateModal">
                  Cancel
                </button>
                <button type="submit" class="btn btn-primary">Create</button>
              </div>
            </form>
          </div>
        </div>
        <div v-if="showEditModal" class="modal-overlay">
          <div class="modal-content" @click.stop>
            <h2 class="modal-title">Edit Limit</h2>

            <form @submit.prevent="updateClient(editingRow)" class="modal-form" style="display: flex; flex-direction: column; flex: 1;">
              <div class="conditional-text">
              <span>For cluster </span>
                  <Multiselect
                    v-model="editingRow.cluster"
                    :options="clusterOptions"
                    placeholder="Select cluster"
                    @input="onEditClusterChange"
                    :allow-empty="true"
                    class="multiselect-sm"
                    :searchable="true"
                  />

                  <span> and campaign </span>
                  <Multiselect
                    v-model="editingRow.campaign"
                    :options="editingRow.filteredCampaigns"
                    label="campaign_name"
                    track-by="id"
                    placeholder="Select campaign"
                    :allow-empty="true"
                    class="multiselect-sm"
                    :searchable="true"
                  />
              <span>If current insurance carrier is </span>
              <Multiselect
                v-model="editingRow.insurance_company"
                :options="insuranceOptions"
                label="name"
                track-by="id"
                placeholder="Select insurance"
                :allow-empty="true"
                class="multiselect-sm"
                :searchable="true" 
              />
              <span> and state is </span>
             <Multiselect
                v-model="editingRow.states"
                :options="stateOptions"
                placeholder="Select state"
                mode="tags"
                class="multiselect-sm"
                :searchable="true"
                :close-on-select="false"
                @input="value => console.log('Multiselect input:', value)"
                @select="value => console.log('Selected:', value)"
              />
              <span> then call to </span>
              <input
                v-model="editingRow.phone_number"
                placeholder="Phone"
                required
                class="small-field phone-field"
              />
               <span> with publisher key </span>
                <input
                  v-model="editingRow.publisher_key"
                  placeholder="publisher key"
                  required
                  class="small-field"
                />
                
                <span> and daily limit </span>
                <input
                  type="number"
                  v-model="editingRow.calls_limit"
                  placeholder="Quota"
                  required
                  class="small-field"
                />
              </div>

            <div class="modal-actions mt-3" style="margin-top: auto; display: flex; justify-content: flex-end; gap: 0.5rem;">

                <button type="button" class="btn btn-secondary" @click="closeEditModal">
                  Cancel
                </button>
                <button type="submit" class="btn btn-primary">Save</button>
              </div>
            </form>
          </div>
        </div>


        <div class="table-responsive">
          <table class="table table-bordered align-middle">
           <colgroup>
            <col style="width: 150px;"> 
            <col style="width: 100px;">
            <col style="width: 100px;">
            <col style="width: 100px;"> 
            <col style="width: 100px;"> 
            <col style="width: 75px;">
            <col style="width: 75px;">
            <col style="width: 50px;">
            <col style="width: 50px;">
          </colgroup>
            <thead class="table-light">
              <tr>
                <th class="campaign-header-cell">
                  <div class="campaign-header-cell-inner">
                    <span>INSURANCE COMPANY</span>
                    <button
                      type="button"
                      ref="insuranceFilterBtn"
                      class="filter-icon-btn"
                      :class="{ active: insuranceFilterActive }"
                      @click.stop="openFilterPopover('insurance', 'insuranceFilterBtn')"
                      title="Filter by insurance company"
                    >
                      <font-awesome-icon icon="filter" />
                      <span v-if="insuranceFilterActive" class="filter-badge">1</span>
                    </button>
                  </div>
                </th>
                <th>DATE</th>
                <th class="campaign-header-cell">
                  <div class="campaign-header-cell-inner">
                    <span>STATE</span>
                    <button
                      type="button"
                      ref="stateFilterBtn"
                      class="filter-icon-btn"
                      :class="{ active: stateFilterSelectedCount > 0 }"
                      @click.stop="openFilterPopover('state', 'stateFilterBtn')"
                      title="Filter by state"
                    >
                      <font-awesome-icon icon="filter" />
                      <span v-if="stateFilterSelectedCount > 0" class="filter-badge">{{ stateFilterSelectedCount }}</span>
                    </button>
                  </div>
                </th>
                <th class="campaign-header-cell">
                  <div class="campaign-header-cell-inner">
                    <span>CLUSTER</span>
                    <button
                      type="button"
                      ref="clusterFilterBtn"
                      class="filter-icon-btn"
                      :class="{ active: clusterFilterActive }"
                      @click.stop="openFilterPopover('cluster', 'clusterFilterBtn')"
                      title="Filter by cluster"
                    >
                      <font-awesome-icon icon="filter" />
                      <span v-if="clusterFilterActive" class="filter-badge">1</span>
                    </button>
                  </div>
                </th>
                <th class="campaign-header-cell">
                  <div class="campaign-header-cell-inner">
                    <span>CAMPAIGN</span>
                    <button
                      type="button"
                      ref="campaignFilterBtn"
                      class="filter-icon-btn"
                      :class="{ active: campaignFilterActive }"
                      @click.stop="openFilterPopover('campaign', 'campaignFilterBtn')"
                      title="Filter by campaign"
                    >
                      <font-awesome-icon icon="filter" />
                      <span v-if="campaignFilterActive" class="filter-badge">1</span>
                    </button>
                  </div>
                </th>
                <th class="campaign-header-cell">
                  <div class="campaign-header-cell-inner">
                    <span>TRANSFER NUMBER</span>
                    <button
                      type="button"
                      ref="phoneFilterBtn"
                      class="filter-icon-btn"
                      :class="{ active: phoneFilterActive }"
                      @click.stop="openFilterPopover('phone', 'phoneFilterBtn')"
                      title="Filter by transfer number"
                    >
                      <font-awesome-icon icon="filter" />
                      <span v-if="phoneFilterActive" class="filter-badge">1</span>
                    </button>
                  </div>
                </th>
                <th class="campaign-header-cell">
                  <div class="campaign-header-cell-inner">
                    <span>PUBLISHER KEY</span>
                    <button
                      type="button"
                      ref="publisherFilterBtn"
                      class="filter-icon-btn"
                      :class="{ active: publisherFilterActive }"
                      @click.stop="openFilterPopover('publisher', 'publisherFilterBtn')"
                      title="Filter by publisher key"
                    >
                      <font-awesome-icon icon="filter" />
                      <span v-if="publisherFilterActive" class="filter-badge">1</span>
                    </button>
                  </div>
                </th>
                <th class="campaign-header-cell">
                  <div class="campaign-header-cell-inner">
                    <span>CALLS LIMIT</span>
                    <button
                      type="button"
                      ref="callsLimitFilterBtn"
                      class="filter-icon-btn"
                      :class="{ active: callsLimitFilterActive }"
                      @click.stop="openFilterPopover('calls_limit', 'callsLimitFilterBtn')"
                      title="Filter by calls limit"
                    >
                      <font-awesome-icon icon="filter" />
                      <span v-if="callsLimitFilterActive" class="filter-badge">1</span>
                    </button>
                  </div>
                </th>
                <th>ACTION</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in rows" :key="i">
                <td>{{ row.insurance_company }}</td>
                <td>{{ row.quota_date }}</td>
                <td>
                  <span v-for="(s, index) in row.states" :key="index">
                    {{ s }}<span v-if="index < row.states.length - 1">, </span>
                  </span>
                </td>
                <td>{{ row.cluster }}</td>
                <td>{{ row.campaign }}</td>
                <td>{{ row.phone_number }}</td>
                <td>{{ row.publisher_key }}</td>
                <td>{{ row.calls_limit }}</td>
                <td class="td-center col-actions">
                    <div class="actions-wrapper">
                      <button
                        class="dots-btn"
                        @click.stop="toggleActions(row.id)"
                        aria-label="Actions"
                      >
                        ⋮
                      </button>

                      <div
                        v-if="openActionsId === row.id"
                        class="actions-popover"
                      >
                        <button
                          class="popover-btn"
                          @click="openEditFromMenu(row)"
                        >
                          ✏ Edit
                        </button>
                          <button
                          class="popover-btn secondary"
                          @click="deleteQuota(row.id)"
                        >
                          🗑 Delete
                        </button>
                      </div>
                    </div>
                </td>
              </tr>
              <tr v-if="rows.length === 0">
                <td colspan="9" class="text-center py-3">No results</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-center align-items-center gap-2 mt-3">
          <button
            class="btn btn-sm btn-outline-primary"
            :disabled="currentPage === 1"
            @click="changePage(currentPage - 1)"
          >
            ◀ Prev
          </button>

          <span>
            Page {{ currentPage }} of {{ totalPages }}
          </span>

          <button
            class="btn btn-sm btn-outline-primary"
            :disabled="currentPage >= totalPages"
            @click="changePage(currentPage + 1)"
          >
            Next ▶
          </button>
        </div>

        <button class="btn-submit mt-3" @click="clearFilters">Clear filters</button>

        
      </article>

      <Teleport to="body">
        <div
          v-if="activeFilter"
          ref="quotaFilterPopover"
          class="filter-popover"
          :style="filterPopoverStyle"
        >
          <div class="filter-popover-header">
            <span class="filter-popover-title">{{ filterPopoverTitle }}</span>
            <button type="button" class="filter-popover-close" @click="closeFilterPopover" aria-label="Close">×</button>
          </div>

          <div class="filter-popover-body">
            <template v-if="activeFilter === 'insurance'">
              <input
                v-model="insuranceFilterSearch"
                type="text"
                class="filter-popover-search"
                placeholder="Search (contains)..."
              />
              <div class="filter-popover-list">
                <label
                  v-for="opt in filteredInsuranceFilterOptions"
                  :key="opt"
                  class="filter-popover-item"
                >
                  <input type="radio" :value="opt" v-model="insuranceFilterSelected" />
                  <span>{{ opt }}</span>
                </label>
                <div v-if="filteredInsuranceFilterOptions.length === 0" class="filter-popover-empty">
                  No insurance companies match
                </div>
              </div>
            </template>

            <template v-else-if="activeFilter === 'state'">
              <input
                v-model="stateFilterSearch"
                type="text"
                class="filter-popover-search"
                placeholder="Search (contains)..."
              />
              <div class="filter-popover-list">
                <label
                  v-for="opt in filteredStateFilterOptions"
                  :key="opt"
                  class="filter-popover-item"
                >
                  <input type="checkbox" :value="opt" v-model="stateFilterSelected" />
                  <span>{{ opt }}</span>
                </label>
                <div v-if="filteredStateFilterOptions.length === 0" class="filter-popover-empty">
                  No states match
                </div>
              </div>
            </template>

            <template v-else-if="activeFilter === 'cluster'">
              <input
                v-model="clusterFilterSearch"
                type="text"
                class="filter-popover-search"
                placeholder="Search (contains)..."
              />
              <div class="filter-popover-list">
                <label
                  v-for="opt in filteredClusterFilterOptions"
                  :key="opt"
                  class="filter-popover-item"
                >
                  <input type="radio" :value="opt" v-model="clusterFilterSelected" />
                  <span>{{ opt }}</span>
                </label>
                <div v-if="filteredClusterFilterOptions.length === 0" class="filter-popover-empty">
                  No clusters match
                </div>
              </div>
            </template>

            <template v-else-if="activeFilter === 'campaign'">
              <input
                v-model="campaignFilterSearch"
                type="text"
                class="filter-popover-search"
                placeholder="Search (contains)..."
              />
              <div class="filter-popover-list">
                <label
                  v-for="opt in filteredCampaignFilterOptions"
                  :key="opt"
                  class="filter-popover-item"
                >
                  <input type="radio" :value="opt" v-model="campaignFilterSelected" />
                  <span>{{ opt }}</span>
                </label>
                <div v-if="filteredCampaignFilterOptions.length === 0" class="filter-popover-empty">
                  No campaigns match
                </div>
              </div>
            </template>

            <template v-else-if="activeFilter === 'phone'">
              <input
                v-model="phoneFilterTemp"
                type="text"
                class="filter-popover-search"
                placeholder="Transfer number (contains)..."
              />
            </template>

            <template v-else-if="activeFilter === 'publisher'">
              <input
                v-model="publisherFilterTemp"
                type="text"
                class="filter-popover-search"
                placeholder="Publisher key (contains)..."
              />
            </template>

            <template v-else-if="activeFilter === 'calls_limit'">
              <input
                v-model="callsLimitFilterTemp"
                type="number"
                min="0"
                step="1"
                class="filter-popover-search"
                placeholder="Calls limit (exact)..."
              />
            </template>
          </div>

          <div class="filter-popover-footer">
            <template v-if="activeFilter === 'state'">
              <button type="button" class="btn btn-sm btn-outline-secondary" @click="selectAllStateFilter">All</button>
              <button type="button" class="btn btn-sm btn-outline-secondary" @click="deselectAllStateFilter">None</button>
            </template>
            <template v-else>
              <button type="button" class="btn btn-sm btn-outline-secondary" @click="clearActiveFilterTemp">Clear</button>
            </template>
            <button type="button" class="btn btn-sm btn-primary" @click="applyActiveFilter">Apply</button>
          </div>
        </div>
      </Teleport>
    </main>
  </div>
</template>

<script>
import UserMenu from '@/components/UserMenu.vue'

export default {
  components: { UserMenu },
  data() {
    return {
      rows: [],
      campaignOptions: [],
      ClustterCampaigns: [],
      clusterOptions: [],       // список всех кластеров
      insuranceOptions: [],
      list_ClustterCampaigns: [],
      stateOptions: [],
      totalItems: 0,
      totalPages: 1,
      openActionsId: null,
      showEditModal: false,
      showCreateModal: false,
      
      creatingRow: {
        insurance_company: null,
        cluster: null,        // новый
        campaign: null,       // новый
        states: [],
        phone_number: "",
        calls_limit: 1,
        publisher_key:"",
      },
      editingRow: {
        id: null,
        insurance_company: null,
        cluster: null,        // новый
        campaign: null,       // новый
        phone_number: "",
        quota_date: "",
        calls_limit: 1,
        publisher_key:"",
        states: []
      },
      currentPage: 1,
      pageSize: 100,
      userName: localStorage.getItem("username") || "User",
      roles: [],
      filters: {
        name: "",
        state: [],
        cluster: "",
        campaign: "",
        phone_number: "",
        publisher_key: "",
        calls_limit: "",
      },

      activeFilter: null,
      activeFilterBtnRef: null,
      filterPopoverStyle: {},
      filterClickOutside: null,

      insuranceFilterSearch: "",
      insuranceFilterSelected: "",
      stateFilterSearch: "",
      stateFilterSelected: [],
      clusterFilterSearch: "",
      clusterFilterSelected: "",
      campaignFilterSearch: "",
      campaignFilterSelected: "",
      phoneFilterTemp: "",
      publisherFilterTemp: "",
      callsLimitFilterTemp: "",
    };
  },
  computed: {
    filterPopoverTitle() {
      const titles = {
        insurance: "Filter by Insurance Company",
        state: "Filter by State",
        cluster: "Filter by Cluster",
        campaign: "Filter by Campaign",
        phone: "Filter by Transfer Number",
        publisher: "Filter by Publisher Key",
        calls_limit: "Filter by Calls Limit",
      };
      return titles[this.activeFilter] || "Filter";
    },
    insuranceFilterActive() {
      return !!this.filters.name;
    },
    stateFilterSelectedCount() {
      return Array.isArray(this.filters.state) ? this.filters.state.length : 0;
    },
    clusterFilterActive() {
      return !!this.filters.cluster;
    },
    campaignFilterActive() {
      return !!this.filters.campaign;
    },
    phoneFilterActive() {
      return !!this.filters.phone_number;
    },
    publisherFilterActive() {
      return !!this.filters.publisher_key;
    },
    callsLimitFilterActive() {
      return this.filters.calls_limit !== "" && this.filters.calls_limit != null;
    },
    filteredInsuranceFilterOptions() {
      const q = (this.insuranceFilterSearch || "").trim().toLowerCase();
      const options = Array.isArray(this.insuranceOptions) ? this.insuranceOptions : [];
      if (!q) return options;
      return options.filter((opt) => String(opt).toLowerCase().includes(q));
    },
    filteredStateFilterOptions() {
      const q = (this.stateFilterSearch || "").trim().toLowerCase();
      const options = Array.isArray(this.stateOptions) ? this.stateOptions : [];
      if (!q) return options;
      return options.filter((opt) => String(opt).toLowerCase().includes(q));
    },
    filteredClusterFilterOptions() {
      const q = (this.clusterFilterSearch || "").trim().toLowerCase();
      const options = Array.isArray(this.clusterOptions) ? this.clusterOptions : [];
      if (!q) return options;
      return options.filter((opt) => String(opt).toLowerCase().includes(q));
    },
    campaignFilterSourceOptions() {
      if (!this.filters.cluster) {
        return Array.isArray(this.list_ClustterCampaigns) ? this.list_ClustterCampaigns : [];
      }
      const cluster = this.filters.cluster;
      const names = (this.ClustterCampaigns || [])
        .filter((c) => c.cluster === cluster)
        .map((c) => c.campaign_name);
      return [...new Set(names)];
    },
    filteredCampaignFilterOptions() {
      const q = (this.campaignFilterSearch || "").trim().toLowerCase();
      const options = this.campaignFilterSourceOptions;
      if (!q) return options;
      return options.filter((opt) => String(opt).toLowerCase().includes(q));
    },
  },
  mounted() {
    const token = localStorage.getItem('token');
    if (!token) {
      window.location.href = '/login';
      return;
    }

    this.check_role()
    this.fetchCampaigns();
    this.fetchClusterCampaigns();
    this.fetchInsurance();
    this.fetchStates();
    this.fetchClusters();
    document.title = "Cross Sales Configurator";
    this.fetchData();
  },
  beforeUnmount() {
    this.removeFilterClickOutside();
  },
  methods: {
    clearFilters() {
      this.closeFilterPopover();
      this.filters = {
        name: "",
        state: [],
        cluster: "",
        campaign: "",
        phone_number: "",
        publisher_key: "",
        calls_limit: "",
      };
      this.currentPage = 1;
      this.fetchData();
    },
    openFilterPopover(filterType, btnRefName) {
      if (this.activeFilter === filterType) {
        this.closeFilterPopover();
        return;
      }
      this.closeFilterPopover();
      this.activeFilter = filterType;
      this.activeFilterBtnRef = btnRefName;
      this.initFilterTemps(filterType);
      this.$nextTick(() => {
        this.positionFilterPopover(btnRefName);
        this.addFilterClickOutside(btnRefName);
      });
    },
    closeFilterPopover() {
      this.activeFilter = null;
      this.activeFilterBtnRef = null;
      this.removeFilterClickOutside();
    },
    initFilterTemps(filterType) {
      if (filterType === "insurance") {
        this.insuranceFilterSearch = "";
        this.insuranceFilterSelected = this.filters.name || "";
      } else if (filterType === "state") {
        this.stateFilterSearch = "";
        this.stateFilterSelected = Array.isArray(this.filters.state) ? [...this.filters.state] : [];
      } else if (filterType === "cluster") {
        this.clusterFilterSearch = "";
        this.clusterFilterSelected = this.filters.cluster || "";
      } else if (filterType === "campaign") {
        this.campaignFilterSearch = "";
        this.campaignFilterSelected = this.filters.campaign || "";
      } else if (filterType === "phone") {
        this.phoneFilterTemp = this.filters.phone_number || "";
      } else if (filterType === "publisher") {
        this.publisherFilterTemp = this.filters.publisher_key || "";
      } else if (filterType === "calls_limit") {
        this.callsLimitFilterTemp = this.filters.calls_limit === "" || this.filters.calls_limit == null
          ? ""
          : String(this.filters.calls_limit);
      }
    },
    positionFilterPopover(btnRefName) {
      const btn = this.$refs[btnRefName];
      if (!btn) return;
      const rect = btn.getBoundingClientRect();
      const gap = 4;
      const popoverWidth = 320;
      let left = rect.left;
      if (left + popoverWidth > window.innerWidth) {
        left = Math.max(8, window.innerWidth - popoverWidth - 8);
      }
      this.filterPopoverStyle = {
        top: `${rect.bottom + gap}px`,
        left: `${left}px`,
      };
    },
    addFilterClickOutside(btnRefName) {
      this.removeFilterClickOutside();
      setTimeout(() => {
        this.filterClickOutside = (e) => {
          const popover = this.$refs.quotaFilterPopover;
          const btn = this.$refs[btnRefName];
          if (popover && popover.contains(e.target)) return;
          if (btn && btn.contains(e.target)) return;
          this.closeFilterPopover();
        };
        document.addEventListener("click", this.filterClickOutside);
      }, 0);
    },
    removeFilterClickOutside() {
      if (this.filterClickOutside) {
        document.removeEventListener("click", this.filterClickOutside);
        this.filterClickOutside = null;
      }
    },
    applyActiveFilter() {
      const filterType = this.activeFilter;
      if (filterType === "insurance") {
        this.filters.name = this.insuranceFilterSelected || "";
      } else if (filterType === "state") {
        this.filters.state = [...this.stateFilterSelected];
      } else if (filterType === "cluster") {
        const prevCluster = this.filters.cluster;
        this.filters.cluster = this.clusterFilterSelected || "";
        if (prevCluster !== this.filters.cluster) {
          this.filters.campaign = "";
        }
      } else if (filterType === "campaign") {
        this.filters.campaign = this.campaignFilterSelected || "";
      } else if (filterType === "phone") {
        this.filters.phone_number = (this.phoneFilterTemp || "").trim();
      } else if (filterType === "publisher") {
        this.filters.publisher_key = (this.publisherFilterTemp || "").trim();
      } else if (filterType === "calls_limit") {
        this.filters.calls_limit = (this.callsLimitFilterTemp || "").trim();
      }
      this.closeFilterPopover();
      this.currentPage = 1;
      this.fetchData();
    },
    clearActiveFilterTemp() {
      const filterType = this.activeFilter;
      if (filterType === "insurance") {
        this.insuranceFilterSelected = "";
      } else if (filterType === "cluster") {
        this.clusterFilterSelected = "";
      } else if (filterType === "campaign") {
        this.campaignFilterSelected = "";
      } else if (filterType === "phone") {
        this.phoneFilterTemp = "";
      } else if (filterType === "publisher") {
        this.publisherFilterTemp = "";
      } else if (filterType === "calls_limit") {
        this.callsLimitFilterTemp = "";
      }
    },
    selectAllStateFilter() {
      this.stateFilterSelected = [...this.filteredStateFilterOptions];
    },
    deselectAllStateFilter() {
      this.stateFilterSelected = [];
    },
    addState(state) {
      if (!this.editingRow.states.includes(state)) {
        this.editingRow.states.push(state);
      }
    },
    removeState(state) {
      this.editingRow.states = this.editingRow.states.filter(s => s !== state);
    },
    isLastState(states, state) {
      return states[states.length - 1].id === state.id;
    },
    openCreateModal() {
        this.creatingRow = {
        insurance_company: null,
        states: [],
        phone_number: "",
        calls_limit: 1,
        cluster: null,
        campaign: null,
        filteredCampaigns: [] // добавляем это поле
      };
      
      // Автоматически заполняем кластер и кампанию из фильтров, если они выбраны
      if (this.filters.cluster) {
        this.creatingRow.cluster = this.filters.cluster;
        
        // Если выбран кластер, фильтруем кампании для него
        if (this.filters.cluster) {
          const filtered = this.ClustterCampaigns
            .filter(c => c.cluster === this.filters.cluster)
            .map(c => c.campaign_name);
          this.creatingRow.filteredCampaigns = filtered;
        }
      }
      
      // Автоматически заполняем кампанию, если она выбрана в фильтрах
      if (this.filters.campaign && this.creatingRow.filteredCampaigns.includes(this.filters.campaign)) {
        this.creatingRow.campaign = this.filters.campaign;
      }
      
      this.showCreateModal = true;
    },
    closeCreateModal() {
    this.showCreateModal = false;
    this.creatingRow = null;
  },
  async createQuota() {
      try {
        if (this.creatingRow.phone_number && !this.isValidUSPhone(this.creatingRow.phone_number)) {
          alert(`phone_number must be a US number (+1XXXXXXXXXX).`);
          return;
        }
        const payload = { ...this.creatingRow };
        const token = localStorage.getItem("token");

        const res = await fetch("/api/create_quota", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify(payload)
        });

        const data = await res.json();
        console.log("Created quota:", data);

        // Логируем действие
        delete payload.filteredCampaigns;
        await fetch("/api/logs", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("token")
          },
          body: JSON.stringify({
            action_type: `create quota ${JSON.stringify(payload)}`,
            username: localStorage.getItem("username")
          })
        });

        this.showCreateModal = false;
        this.creatingRow = null;
        this.fetchData(); // обновляем таблицу
      } catch (err) {
        console.error("Create failed:", err);
      }
    },
    changePage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
      this.fetchData();
    },
    async updateClient(row) {
      try {
        if (row.phone_number && !this.isValidUSPhone(row.phone_number)) {
          alert(`phone_number must be a US number (+1XXXXXXXXXX).`);
          return;
        }
        const payload = { 
          ...row, 
          states: Array.isArray(row.states) ? row.states : [row.states] 
        };
        console.log("payload")
        console.log(payload)
        const token = localStorage.getItem("token");

        delete payload.filteredCampaigns;
        const res = await fetch("/api/update_quota", {
          method: "POST", // или PUT, в зависимости от API
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify(payload)
        });

        const data = await res.json();
        console.log("Server response:", data);

        await fetch("/api/logs", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify({
            action_type: `update quota ${JSON.stringify(payload)}`,
            username: localStorage.getItem("username")
          })
        });

        // Обновляем интерфейс
        this.showEditModal = false;
        this.editingRow = null;
        this.fetchData();
      } catch (err) {
        console.error("Update failed:", err);
      }
    },
    onCreateClusterChange(clusterName) {
        console.log("ClustterCampaigns", this.ClustterCampaigns);
        
        // Сначала фильтруем, потом получаем только имена кампаний
        const filtered = this.ClustterCampaigns
            .filter(c => c.cluster === clusterName)
            .map(c => c.campaign_name);  // Берем только campaign_name
        
        this.creatingRow.filteredCampaigns = filtered;
        
        console.log("check - только имена кампаний:", filtered);
        console.log("check - как обычный массив:", [...filtered]);
        
        this.creatingRow.campaign = null;
    },
    
    onEditClusterChange(clusterName) {
        console.log("=== onEditClusterChange ===");
        console.log("ClustterCampaigns:", this.ClustterCampaigns);
        console.log("Selected cluster:", clusterName);
        
        if (!clusterName) {
            console.log("No cluster selected, clearing filtered campaigns");
            this.editingRow.filteredCampaigns = [];
            this.editingRow.campaign = null;
            return;
        }
        
        // Фильтруем и получаем только имена кампаний
        const filtered = this.ClustterCampaigns
            .filter(c => c.cluster === clusterName)
            .map(c => c.campaign_name);  // Берем только campaign_name
        
        this.editingRow.filteredCampaigns = filtered;
        
        console.log("Filtered campaigns (names only):", filtered);
        console.log("Filtered length:", filtered.length);
        
        // Сбрасываем выбранную кампанию
        this.editingRow.campaign = null;
        console.log("Campaign selection reset");
        
        // Если отфильтрованная кампания только одна, можно автоматически выбрать её
        if (filtered.length === 1) {
            this.editingRow.campaign = filtered[0];
            console.log("Auto-selected campaign:", this.editingRow.campaign);
        }
        
        console.log("=== onEditClusterChange END ===");
    },
    async fetchCampaigns() {
        const token = localStorage.getItem("token");
        const res = await fetch("/api/campaigns", {
          headers: { "Authorization": `Bearer ${token}` }
        });
        const data = await res.json();
        this.campaignOptions = data.items || [];
    },
    async fetchInsurance() {
        const token = localStorage.getItem("token");
        const res = await fetch("/api/quota_insurance", {
          headers: { "Authorization": `Bearer ${token}` }
        });
        const data = await res.json();
        this.insuranceOptions = data.items || [];
    }, 
    async fetchClusters() {
      const token = localStorage.getItem("token");
      const res = await fetch("/api/clusters", {
        headers: { "Authorization": `Bearer ${token}` }
      });
      const data = await res.json();
      this.clusterOptions = data.items || [];
      console.log("clusterOptions")
      console.log(this.clusterOptions)
    },

    async fetchClusterCampaigns() {
      const token = localStorage.getItem("token");
      const res = await fetch("/api/campaigns_cluster", {
        headers: { "Authorization": `Bearer ${token}` }
      });
      const data = await res.json();
      this.ClustterCampaigns = data.items || [];
      this.list_ClustterCampaigns = data.items 
      ? data.items.map(item => item.campaign_name) 
      : [];
  
    },
    async deleteQuota(id) {
        if (!confirm("Are you sure you want to delete this quota?")) return;

        const token = localStorage.getItem("token");

        try {
          const res = await fetch(`/api/delete_quota/${id}`, {
            method: "DELETE",
            headers: {
              "Authorization": `Bearer ${token}`
            }
          });

          if (!res.ok) {
            const errorData = await res.json();
            alert(`Failed to delete: ${errorData.error || res.statusText}`);
            return;
          }
           await fetch("/api/logs", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
              },
              body: JSON.stringify({
                action_type: `delete quota with id ${id}`,
                username: localStorage.getItem("username")
              })
            });


          this.fetchData(); // обновляем таблицу после удаления
          this.openActionsId = null; // закрываем popover
        } catch (e) {
          console.error("Delete failed:", e);
          alert("Delete failed. See console for details.");
        }
      },
    async check_role(){
      const token = localStorage.getItem('token');
      const params = new URLSearchParams({ user: this.userName });
      const res = await fetch(`/api/role?${params.toString()}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      this.roles = data.roles;
      return this.roles
    },
    toggleActions(id) {
      this.openActionsId = this.openActionsId === id ? null : id
    },
    isValidUSPhone(phone) {
      if (!phone) return false

      return /^\+1\d{10}$/.test(phone)
    },

    openEditFromMenu(client) {
      this.openActionsId = null;
      this.openEditModal(client);
    },

   openEditModal(client) {
      console.log("Client states:", client.states);
      console.log("Cluster selected:", client.cluster);  // Логируем выбранный кластер

      this.editingRow = {
        id: client.id,
        insurance_company: client.insurance_company,
        phone_number: client.phone_number,
        quota_date: client.quota_date,
        calls_limit: client.calls_limit,
        states: client.states ? [...client.states] : [],
        cluster: client.cluster || null,  // Проверяем, что кластер не null
        campaign: client.campaign
      };

      console.log("editingRow.states AFTER:", this.editingRow.states);
      console.log("editingRow.cluster AFTER:", this.editingRow.cluster);  // Проверяем, что кластер установлен

      this.showEditModal = true;
      this.$nextTick(() => {
          // Если у клиента есть кластер, сразу фильтруем кампании
          if (this.editingRow.cluster) {
              console.log("Auto-filtering campaigns for cluster:", this.editingRow.cluster);
              this.onEditClusterChange(this.editingRow.cluster);
          } else {
              // Если кластера нет, показываем все кампании или очищаем список
              this.editingRow.filteredCampaigns = this.ClustterCampaigns.map(c => c.campaign_name);
              console.log("No cluster, showing all campaigns");
          }
      });

    },
    closeEditModal() {
      this.showEditModal = false
      this.editingRow = null
    },
    async fetchStates() {
      const token = localStorage.getItem("token");
      const res = await fetch("/api/states", {
        headers: { "Authorization": `Bearer ${token}` }
      });
      const data = await res.json();
      this.stateOptions = data.items;
      console.log("stateOptions")
      console.log(this.stateOptions)
    },
    async fetchData() {
      const token = localStorage.getItem('token');
      const params = new URLSearchParams({
        page: this.currentPage,
        page_size: this.pageSize,
      });

      const scalarFilters = [
        "name",
        "cluster",
        "campaign",
        "phone_number",
        "publisher_key",
        "calls_limit",
      ];
      scalarFilters.forEach((key) => {
        const value = this.filters[key];
        if (value !== null && value !== undefined && value !== "") {
          params.set(key, value);
        }
      });

      const states = this.filters.state;
      if (Array.isArray(states) && states.length > 0) {
        states.forEach((s) => params.append("state", s));
      }

      const res = await fetch(`/api/data_quota?${params.toString()}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.status === 401) {
        localStorage.removeItem('token');
        this.$router.push('/login');
        return;
      }
      const data = await res.json();
      this.rows = data.items || [];
      this.totalItems = data.total || 0;
      this.totalPages = Math.ceil(this.totalItems / this.pageSize);
      return data;
    },
  },
  watch: {
    editingRow: {
      immediate: true,
      handler(row) {
        if (row && row.states) {
          this.editingRowStatesCopy = [...row.states];
        }
      }
    },
  }
};
</script>

<style scoped>

.daterange {
  cursor: pointer;
  background-color: #fff;
}
#reportPage {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background: linear-gradient(135deg, #1e3c72, #2a5298);
  padding: 20px 10px;
}

#reportPage main {
  display: flex;
  justify-content: center;
  width: 100%;
}

#reportPage article {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: none;
}

.title-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.login-title {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  color: #4e54c8;
}

.panel-action-btn {
  background: linear-gradient(135deg, #6a11cb, #2575fc);
  border: none;
  border-radius: 8px;
  color: white;
  font-weight: 600;
  font-size: 16px;
  padding: 10px 20px;
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 150px;
  max-width: 150px;
  height: 106.59px;
  flex-shrink: 0;
  margin-left: auto;
}

.panel-action-btn:hover {
  transform: translateY(-2px);
}

.panel-action-btn:active {
  transform: translateY(1px);
}

.btn-submit {
  width: 200px;
  max-width: 100%;
  display: inline-block;
  background: linear-gradient(135deg, #6a11cb, #2575fc);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease, transform 0.2s ease;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.btn-submit:hover {
  background: linear-gradient(135deg, #5a0fc1, #1e63d6);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
}

.btn-submit:active {
  transform: translateY(1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.summary-panels-wrapper {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.summary-panels-container {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 20px;
  flex-wrap: wrap;
}

.summary-panels {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  flex: 1;
}

.datepicker-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}


.datepicker-wrapper .calendar-icon {
  position: absolute;
  right: 10px;
  color: #4e54c8;
  cursor: pointer;
}

.datepicker-wrapper input {
  padding-right: 30px;
  border-radius: 12px;
  border: 1px solid #ccc;
  font-size: 12px;
  height: 32px;
}

.datepicker-wrapper input:focus {
  border-color: #4e54c8;
  box-shadow: 0 0 0 2px rgba(78, 84, 200, 0.2);
}


.panel {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 110px;
  background: #f0f4ff;
  padding: 10px 15px;
  border-radius: 4px;
  text-align: center;
  flex: 1 1 150px;
  min-width: 150px;
  max-width: 150px;
}

.panel-title {
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
}

.panel-value {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
}
.v-select {
  font-size: 12px;
  border-radius: 8px;
}

.v-select .vs__dropdown-toggle {
  min-height: 32px;
}

.v-select .vs__selected {
  font-size: 12px;
}


.table-responsive table {
  min-width: 700px;
  -webkit-overflow-scrolling: touch;
  table-layout: fixed;
  width: 100%
}

table {
  width: 100%;
  table-layout: auto;
  font-size: 10px;
}

th, td {
  word-wrap: break-word;
  vertical-align: middle !important;
}

.filter-input,
.v-select .vs__dropdown-toggle {
  height: 45px;
  min-height: 32px;
  font-size: 12px;
  padding: 6px 8px;
}





.table-responsive {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive table {
  min-width: 1000px;
  width: 100%;
  table-layout: auto;
}

@media (max-width: 768px) {
  .table-responsive table {
    min-width: 700px;
  }
  th, td {
    white-space: nowrap;
  }
}
@media (max-width: 768px) {
  .login-title { font-size: 22px; }
  table { font-size: 10px; }
  .filter-input { font-size: 11px; padding: 4px 6px; }
  .panel-action-btn { max-width: 100%; padding: 8px 16px; height: 110px; }
  .summary-panels-container { gap: 10px; }
}

.col-active {
  width: 140px;
  min-width: 140px;
  max-width: 140px;
  text-align: center;
}

.actions-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.dots-btn {
  background: none;
  border: none;
  padding: 4px 6px;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  color: #4f46e5;
}

.dots-btn:hover {
  color: #4338ca;
}

.actions-popover {
  position: absolute;
  top: 50%;
  right: 100%;
  transform: translate(-8px, -50%);
  background: #ffffff;
  border-radius: 10px;
  padding: 6px;
  min-width: 150px;
  box-shadow:
    0 10px 25px rgba(0, 0, 0, 0.15),
    0 0 0 1px rgba(0, 0, 0, 0.05);
  z-index: 20;
}

.popover-btn {
  width: 100%;
  background: none;
  border: none;
  padding: 10px 12px;
  font-size: 14px;
  text-align: left;
  border-radius: 8px;
  cursor: pointer;
  color: #111827;
}
.filter-multiselect-insurance .vs__dropdown-toggle {
width: 200px;
}

.filter-multiselect-other .vs__dropdown-toggle {
width: 160px;
}
.filter-multiselect-insurance .vs__selected,
.filter-multiselect-insurance .vs__placeholder,
.filter-multiselect-other .vs__selected,
.filter-multiselect-other .vs__placeholder {
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
}

.popover-btn:hover {
  background: #f3f4f6;
}

.popover-btn.secondary {
  color: #dc2626;
}
.confirm-number-btn {
  background: none;
  border: none;
  padding: 4px;
  margin-left: 8px;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  color: #9ca3af;
  transition: color 0.15s ease, transform 0.15s ease;
}

.confirm-number-btn:hover {
  color: #16a34a;
  transform: scale(1.1);
}

.confirm-number-btn:active {
  transform: scale(0.95);
}
.popover-btn.secondary:hover {
  background: #fee2e2;
}
.login-title {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  color: #4e54c8;
}
.toggle-switch {
  position: relative;
  width: 50px;
  height: 26px;
}

.toggle-switch input {
  opacity: 0;
  width: 50px;
  height: 26px;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  margin: 0;
}


.toggle-switch .slider {
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  border-radius: 26px;
  transition: 0.4s;
}
.company-alone {
  grid-column: 1 / -1;
}

.company-alone input {
  max-width: calc(50% - 7.5px); 
}
.toggle-switch .slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  border-radius: 50%;
  transition: 0.4s;
}

.toggle-switch input:checked + .slider {
  background-color: #4f46e5;
}

.toggle-switch input:checked + .slider:before {
  transform: translateX(24px);
  
}
.remove-number-btn {
  background: none;
  border: none;
  padding: 4px;
  margin-left: 8px;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  color: #9ca3af;
  transition: color 0.15s ease, transform 0.15s ease;
}

.remove-number-btn:hover {
  color: #dc2626;
  transform: scale(1.1);
}

.remove-number-btn:active {
  transform: scale(0.95);
}

/* Layout */
#reportPage {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px 10px;
  background: linear-gradient(135deg, #1e3c72, #2a5298);
}

.report-card {
  width: 100%;
  max-width: none;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.page-header {
  margin-bottom: 14px;
}


.page-header h1 {
  margin: 0;
  font-size: 28px;
}

.subtitle {
  margin-top: 4px;
  color: #666;
}

/* Table */
.table-wrapper {
  padding: 0;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 10px;
}

.table th,
.table td {
  border: 1px solid #e5e7eb;
  padding: 10px 12px;
  vertical-align: middle;
}

.table th {
  background: #f9fafb;
  font-weight: 600;
  color: #374151;
  text-align: center;
}
.td-right {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.td-center {
  text-align: center;
}

.table tbody tr:hover {
  background-color: #f9fafb;
}

.empty {
  text-align: center;
  padding: 20px;
  color: #9ca3af;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.modal-content {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  max-width: 2200px;
  max-height: 90vh;
  width: 90%;    
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
  animation: scaleIn 0.2s ease;
}
.multiselect-sm,
.filter-input {
border-radius: 8px;
}
.filter-input,
.v-select .vs__dropdown-toggle {
border-radius: 8px;
}

@keyframes scaleIn {
  from { transform: scale(0.8); opacity: 0; }
  to   { transform: scale(1); opacity: 1; }
}

.modal-form {
  min-height: 400px;
  height: 100%; 
}

.modal-form .form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 20px;
  min-height: 150px;
  height: 100%; 
}
.modal-actions-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}


@keyframes scaleIn {
  from { transform: scale(0.8); opacity: 0; }
  to   { transform: scale(1); opacity: 1; }
}

.multiselect-sm {
width: 160px;
min-width: 200px;
max-width: 200px;
flex-shrink: 0;
}

.multiselect-sm .vs__dropdown-toggle {
height: 32px;
  min-height: 32px;
  font-size: 12px;
  padding: 6px 8px;
}


.multiselect-sm .vs__selected,
.multiselect-sm .vs__placeholder {
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
}

.multiselect-sm .vs__placeholder { 
  font-size: 12px; 
  line-height: 32px; 
  color: #6c757d; 
}
.modal-content .multiselect-sm .vs__dropdown-menu {
max-height: 32px; 
overflow-y: auto;
}
.modal-content .vs__dropdown-menu {
max-height: 32px;
overflow-y: auto;
}
.vs__dropdown-menu {
max-height: 32px !important;
overflow-y: auto !important;
}

.multiselect-sm .vs__dropdown-menu {
font-size: 12px;
overflow-y: auto;
box-sizing: border-box;
} 

.right-actions {
  display: flex;
  gap: 12px;
}
.conditional-text {
display: inline-flex;      
flex-wrap: wrap;           
align-items: center;
column-gap: 4px;
row-gap: 6px;
font-size: 14px;
line-height: 1.4;
}
.conditional-text span {
white-space: nowrap;
}
.conditional-text .multiselect-sm {
display: inline-flex !important;
vertical-align: baseline;
}

.conditional-text .vs__dropdown-toggle {
height: 32px;
min-height: 32px;
font-size: 13px;
padding: 0 6px;
}


.conditional-text .small-field {
width: 100px;
height: 40px;
min-height: 32px;
padding: 6px 8px;             
font-size: 13px;
line-height: 1.4;
border: 1px solid #d1d5db;   
border-radius: 4px;            
background-color: #fff;
box-sizing: border-box;
outline: none;
}

.conditional-text .small-field:focus {
border-color: #4e54c8; 
box-shadow: 0 0 0 2px rgba(78, 84, 200, 0.2);
}

.modal-actions {
position: absolute !important;
bottom: 20px !important;
right: 24px !important;
left: 24px !important;
margin-top: 0 !important;
}
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.status-badge .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

/* ACTIVE */
.status-badge.active {
  background: #ecfdf5;
  color: #065f46;
}

.status-badge.active .dot {
  background: #10b981;
}

/* INACTIVE */
.status-badge.inactive {
  background: #fef2f2;
  color: #7f1d1d;
}
.status-badge.inactive .dot {
  background: #ef4444;
}
.fade-enter-active, .fade-leave-active { transition: opacity 0.2s; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

.table th {
  background: #f7f8fa;
  font-weight: 600;
  text-align: left;
}

.table td.center,
.table th.center {
  text-align: center;
}

.table tr:hover {
  background: #fafafa;
}

/* Inputs */
.table-input {
  width: 100%;
  height: 100%;
  padding: 6px 8px;
  box-sizing: border-box;
  border: 1px solid #ddd;
  border-radius: 6px;
}

/* Buttons */
.btn {
  padding: 6px 14px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: 500;
}

.btn-primary {
  background: #4f46e5;
  color: white;
}

.btn-primary:hover {
  background: #4338ca;
}

.btn-secondary {
  background: #e5e7eb;
  color: #111;
}

.btn-secondary:hover {
  background: #d1d5db;
}
.transfer-numbers-wrapper {
  max-height: 300px;
  overflow-y: auto;  
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 8px;
  margin-bottom: 8px;
}

transfer-number-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.transfer-number-row input {
  flex: 1;
  width: 150px; 
  padding: 10px 12px;
  font-size: 16px;
  min-height: 40px;
  border-radius: 6px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}

.remove-number-btn,
.confirm-number-btn {
  background: none;
  border: none;
  padding: 4px;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  transition: color 0.15s ease, transform 0.15s ease;
}

.remove-number-btn {
  color: #9ca3af;
}

.remove-number-btn:hover {
  color: #dc2626;
  transform: scale(1.1);
}

.remove-number-btn:active {
  transform: scale(0.95);
}

.confirm-number-btn {
  color: #9ca3af;
}

.confirm-number-btn:hover {
  color: #16a34a;
  transform: scale(1.1);
}

.confirm-number-btn:active {
  transform: scale(0.95);
}

/* Footer */
.footer-actions {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end; 
}
.sms-toggle {
  display: inline-block;
  cursor: pointer;
  font-size: 24px;
  text-align: center;
  width: 100%;
  user-select: none;
}

.checkbox-wrapper {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 40px;
  text-align: center;
  cursor: pointer;
}
.multiselect-dropdown {
  max-height: 32px;
  overflow-y: auto;
  box-sizing: border-box;
}

.checkbox-wrapper input[type="checkbox"] {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  cursor: pointer;
}

.custom-check {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  width: 40px;
  height: 40px;
  border: 2px solid #ccc;
  border-radius: 6px;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s;
}
.custom-check:hover {
  background-color: #f0f0f0;
  border-color: #888;
}


/* Empty state */
.empty {
  text-align: center;
  padding: 20px;
  color: #888;
  
}
.table-section {
  padding-left: 16px;
  padding-right: 16px;
}
@media (min-width: 1024px) {
  .table-section {
    padding-left: 160px;
    padding-right: 160px;
  }
}

@media (max-width: 768px) {
  .modal-content {
    width: 95%;      
    max-width: 95%; 
    padding: 16px;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .transfer-numbers-wrapper {
    max-height: 200px;
  }

  .form-field input,
  .form-field .vs__dropdown-toggle {
    font-size: 14px;
  }
}

@media (max-width: 768px) {
  .modal-form .form-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .modal-content {
    width: 95%;
    max-width: 95%;
    padding: 16px;
  }

  .transfer-numbers-wrapper {
    max-height: 200px;
  }

  .form-field input,
  .form-field .vs__dropdown-toggle {
    font-size: 14px;
  }
}
@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    max-width: 95%;
    padding: 16px;
    max-height: 85vh;
  }
}
.modal-content {
  max-height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.table-wrapper {
  overflow: visible;
}
.table-scroll {
  overflow-x: auto;
}
.table-actions {
  display: flex;
  gap: 6px;
  justify-content: center;
}

.table-actions .btn {
  padding: 4px 8px;
  font-size: 12px;
  border-radius: 4px;
  min-width: 60px;
  text-align: center;
  border: 1px solid #ccc;
  background: white; 
}

.table-actions .btn-primary {
  background: white;
  color: #4f46e5;
  border-color: #4f46e5;
  border: 1px solid #4f46e5; 
}
.table-actions .btn-primary:hover {
  background: #4338ca;
}

.table-actions .btn-danger {
    background: white;
  color: #ef4444;
  border-color: #ef4444;
  border: 1px solid #ef4444;
}
.table-actions .btn-danger:hover {
  background: #fee2e2; 
}

.btn-danger {
  background: #ef4444;
  color: white;
}

.btn-danger:hover {
  background: #dc2626;
}


.col-actions {
  width: 140px;
  min-width: 140px;
  max-width: 140px;
}


.login-title .brand {
  color: #4e54c8;
  text-decoration: none;
}
.login-title .brand:hover {
  text-decoration: underline;
}
.modal-title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

.modal-section {
  margin-bottom: 25px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #555;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.form-field {
  display: flex;
  flex-direction: column;
}

.form-field label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 6px;
  padding-left: 4px; 
  color: #555;
}

.form-field input {
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 14px;
  outline: none;
}

.form-field input:disabled {
  background: #f7f7f7;
  color: #888;
}

.checkbox-field {
  display: flex;
  align-items: center;
  gap: 8px;
}

.modal-actions {
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}
.conditional-text .phone-field {
  width: 180px;
}

/* Transition */
.fade-enter-active, .fade-leave-active { transition: opacity 0.2s; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

table th:nth-child(4), /* CLUSTER */
.table td:nth-child(4) {
  min-width: 120px !important;
  max-width: 120px !important;
  width: 120px !important;
}

.table th:nth-child(5), /* CAMPAIGN */
.table td:nth-child(5) {
  min-width: 140px !important;
  max-width: 140px !important;
  width: 140px !important;
}

.grafana-sidebar {
display: flex;
flex-direction: column;
width: 150px;
padding: 8px 6px;
background: #f5f5fa;
border-right: 1px solid #2d2d32;
overflow-y: auto;
max-height: 320px;
gap: 2px;
}

.grafana-sidebar button {
background: none;
border: none;
color: #000000;
font-size: 12px;
padding: 6px 10px;
text-align: left;
border-radius: 4px;
cursor: pointer;
white-space: nowrap;
transition: background 0.15s;
}

.grafana-sidebar button:hover {
background: #2d2d32;
color: #ffffff; 
}

.grafana-sidebar-divider {
height: 1px;
background: #2d2d32;
margin: 4px 0;
}

.grafana-datepicker {
width: 300px !important;
font-size: 11px;
}

.grafana-datepicker .dp__menu {
font-size: 11px !important;
}

.grafana-datepicker .datepicker,
.grafana-datepicker .datepicker * {
font-size: 11px !important;
}

.grafana-datepicker .datepicker__input {
font-size: 11px !important;
}

.grafana-datepicker :deep(.dp__menu) {
font-size: 11px !important;
}

.grafana-datepicker :deep(.dp__calendar) {
font-size: 11px !important;
}

.grafana-datepicker :deep(.dp__cell_inner) {
font-size: 11px !important;
}

.grafana-datepicker :deep(.dp__input) {
font-size: 11px !important;
height: 32px !important;
padding: 4px 8px 4px 35px !important;
}

.table-top-filters {
display: flex;
align-items: center;
gap: 8px;
margin-bottom: 16px;
}

.campaign-header-cell {
vertical-align: bottom !important;
}
.campaign-header-cell-inner {
display: inline-flex;
align-items: center;
gap: 6px;
}
.campaign-header-cell span {
font-weight: 600;
}
.filter-icon-btn {
position: relative;
width: auto;
height: auto;
padding: 2px 4px;
border: none;
border-radius: 4px;
background: transparent;
color: #6c757d;
cursor: pointer;
display: inline-flex;
align-items: center;
justify-content: center;
transition: color 0.2s;
}
.filter-icon-btn:hover {
color: #4e54c8;
}
.filter-icon-btn.active {
color: #4e54c8;
}
.filter-badge {
position: absolute;
top: -6px;
right: -6px;
min-width: 14px;
height: 14px;
padding: 0 3px;
font-size: 9px;
font-weight: 700;
color: #fff;
background: #4e54c8;
border-radius: 7px;
display: flex;
align-items: center;
justify-content: center;
}
.filter-popover {
position: fixed;
z-index: 9999;
background: #fff;
border-radius: 8px;
box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
border: 1px solid #e0e0e0;
width: 320px;
max-height: 400px;
display: flex;
flex-direction: column;
}
.filter-popover-header {
display: flex;
justify-content: space-between;
align-items: center;
padding: 10px 12px;
border-bottom: 1px solid #eee;
}
.filter-popover-title {
font-size: 13px;
font-weight: 600;
color: #1a1a2e;
}
.filter-popover-close {
width: 24px;
height: 24px;
padding: 0;
border: none;
background: none;
font-size: 18px;
color: #888;
cursor: pointer;
line-height: 1;
}
.filter-popover-close:hover {
color: #333;
}
.filter-popover-body {
padding: 10px 12px;
overflow-y: auto;
flex: 1;
}
.filter-popover-search {
width: 100%;
padding: 8px 10px;
border: 1px solid #ced4da;
border-radius: 6px;
font-size: 13px;
margin-bottom: 8px;
box-sizing: border-box;
}
.filter-popover-search:focus {
outline: none;
border-color: #4e54c8;
}
.filter-popover-list {
max-height: 220px;
overflow-y: auto;
border: 1px solid #eee;
border-radius: 6px;
}
.filter-popover-item {
display: flex;
align-items: center;
gap: 8px;
padding: 6px 10px;
cursor: pointer;
border-bottom: 1px solid #f5f5f5;
margin: 0;
font-size: 12px;
}
.filter-popover-item:last-child {
border-bottom: none;
}
.filter-popover-item:hover {
background: #f8f9ff;
}
.filter-popover-item input[type="checkbox"],
.filter-popover-item input[type="radio"] {
width: 14px;
height: 14px;
cursor: pointer;
}
.filter-popover-empty {
padding: 16px;
text-align: center;
color: #888;
font-size: 12px;
}
.filter-popover-footer {
display: flex;
justify-content: flex-end;
gap: 6px;
padding: 10px 12px;
border-top: 1px solid #eee;
}

</style>